import { useQuery } from "@tanstack/react-query";
import apiClient from "@/src/services/api/axios";

export type BlocksLanguage = {
  itemId: string;
  languageName: string;
  languageCode: string;
};

export const useGetLanguages = () => {
  return useQuery({
    queryKey: ["languages"],
    queryFn: async () => {
      const res = await apiClient.get(
        process.env.EXPO_PUBLIC_GET_LANGUAGES as string,
      );
      return res.data as BlocksLanguage[];
    },
  });
};
